var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.schema.title,"message":_vm.schema.description}},[_c('b-datetimepicker',{attrs:{"value":_vm._value,"datetime-formatter":_vm.formatter,"datetime-parser":_vm.parser,"placeholder":"Click to select a date and time"},on:{"input":function($event){_vm.$emit('input', _vm.formatter($event))}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }